import React, { useEffect, useState } from "react";
import {
	Box,
	Container,
	Grid,
	Button,
	CircularProgress,
	Typography,
	TableContainer,
	Table,
	TableRow,
	TableCell,
	TableBody,
	Checkbox,
} from "@mui/material";
import Page from "../../../components/Page";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getAlumne } from "../../../database/API";
import Title from "../../../components/Title";
import Activitat from "../../../components/Activitat";
import { styled } from "@mui/material";

const PaperBox = styled(Box)(({ theme }) => ({
	backgroundColor: "white",
	borderRadius: 5,
	padding: 30,
	boxShadow:
		"0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
}));

const UserView = () => {
	const navigate = useNavigate();
	const [alumne, setAlumne] = useState();
	const [loading, setLoading] = useState(true);
	const { key } = useParams();

	useEffect(() => {
		const get = async () => {
			const { alumne } = await getAlumne(key);
			setAlumne(alumne);
			setLoading(false);
		};
		get();
	}, [key]);

	const info = [
		{ id: "Nom", value: alumne?.nom },
		{ id: "E-mail", value: alumne?.email },
		{ id: "Telèfon", value: alumne?.telefon },
		{ id: "Telèfon 2", value: alumne?.telefon2 },
		{ id: "Escola", value: alumne?.escola },
		{ id: "Curs", value: alumne?.curs },
		{ id: "Talla samarreta", value: alumne?.talla },
		{ id: "Edat", value: alumne?.edat + " anys" },
		{
			id: "AFA",

			value: <Checkbox disabled checked={Number(alumne?.ampa)} />,
		},
		{
			id: "Dret d'imatge",
			value: <Checkbox disabled checked={Number(alumne?.dret)} />,
		},
		{ id: "Observacions", value: alumne?.observacions },
	];

	const info_titular = [
		{ id: "Nom", value: alumne?.nom_titular },
		{ id: "DNI", value: alumne?.dni },
		{ id: "Número de compte", value: alumne?.n_compte },
	];

	return (
		<Page title={"Detalls alumne"}>
			<Container maxWidth={false}>
				<Box mb={3}>
					<Title
						title={"Detalls alumne"}
						button={
							<Button
								variant="contained"
								onClick={() => navigate("edit")}
							>
								Editar
							</Button>
						}
					/>
				</Box>
				{loading ? (
					<CircularProgress />
				) : (
					<Grid container spacing={4}>
						<Grid item size={{ xs: 12, md: 6 }}>
							<PaperBox>
								<Box mb={3}>
									<Typography variant="h3">
										Informació
									</Typography>
								</Box>
								<TableContainer>
									<Table
										sx={{ minWidth: 200 }}
										aria-label="simple table"
									>
										<TableBody>
											{info?.map((row) => (
												<TableRow
													hover
													key={row.id}
													sx={{
														"&:last-child td, &:last-child th":
															{ border: 0 },
													}}
												>
													<TableCell
														component="th"
														scope="row"
													>
														{row.id}
													</TableCell>
													<TableCell align="right">
														{row.value}
													</TableCell>
												</TableRow>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							</PaperBox>
							<PaperBox mt={4}>
								<Box mb={3}>
									<Typography variant="h3">
										Informació econòmica
									</Typography>
								</Box>

								<TableContainer>
									<Table
										sx={{ minWidth: 200 }}
										aria-label="simple table"
									>
										<TableBody>
											{info_titular?.map((row) => (
												<TableRow
													hover
													key={row.id}
													sx={{
														"&:last-child td, &:last-child th":
															{ border: 0 },
													}}
												>
													<TableCell
														component="th"
														scope="row"
													>
														{row.id}
													</TableCell>
													<TableCell align="right">
														{row.value}
													</TableCell>
												</TableRow>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							</PaperBox>
						</Grid>
						<Grid item size={{ xs: 12, md: 6 }}>
							<PaperBox>
								<Box mb={3}>
									<Typography variant="h3">
										Activitats apuntades
									</Typography>
								</Box>
								{alumne?.activitats.map((activitat) => (
									<Link
										to={`/admin/activitats/` + activitat.id}
										style={{ textDecoration: "none" }}
									>
										<Activitat activitat={activitat} />
									</Link>
								))}
							</PaperBox>
							<PaperBox
								mt={3}
								justifyContent="space-between"
								display="flex"
							>
								<Typography variant="h3">
									Total mensual
								</Typography>
								<Box>
									<Typography variant="h4">
										{alumne?.activitats
											.map((activitat) =>
												Number(alumne?.ampa)
													? activitat?.preu_soci
													: activitat.preu
											)
											.reduce(
												(acc, curr) =>
													acc + parseInt(curr, 10),
												0
											)}{" "}
										€
									</Typography>

									<Typography variant="body2" fontSize={12}>
										{Number(alumne?.ampa)
											? "Preu soci"
											: "Preu normal"}
									</Typography>
								</Box>
							</PaperBox>
						</Grid>
					</Grid>
				)}
			</Container>
		</Page>
	);
};

export default UserView;
